import React, { useState, useEffect } from "react";
import CircularProgress from '@mui/material/CircularProgress';
import {
  Container,
  Typography,
  Paper,
  Box,
  TextField,
  Modal,
  Grid,
  MenuItem,
  Select,
  Button,
  Divider,
  Tooltip,
  IconButton,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { Info as InfoIcon } from "@mui/icons-material";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function UpdateEnquiry() {
  const [isLoading, setIsLoading] = useState(true);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  let navigate = useNavigate();
  const [selectedPurpose, setSelectedPurpose] = useState("");
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSub, setSelectedSub] = useState("");
  const [loadingBarProgress, setLoadingBarProgress] = useState('');
  const [selectedMode, setSelectedMode] = useState("");
  const [purposes, setPurposes] = useState([]);
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [modes, setModes] = useState([]);

  // Info modal state
  const [showInfoModal, setShowInfoModal] = useState(false);

  const [enquiryData, setEnquiryData] = useState({
    enquiryCode: "",
    enquiryDate: "",
    followupDate: "",
    purposeId: "",
    modeId: "",
    classId: "",
    contactNo: "",
    parentAndGurdianName: "",
    reference: "",
    emailId: "",
    remark: "",
    createdBy: 0, // Replace with actual user ID if available
    teacherId: "",
    studentName: "",
    motherName: "",
    amount: 0,
    alternateMobile: ""
  });

  const { enquiryId } = useParams();

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      setLoadingBarProgress(30);
      const url = process.env.REACT_APP_BASE_URL;
      const response = await fetch(`${url}/Enquiry/EnquirySchoolId?id=${enquiryId}`, {

        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Authorization": sessionStorage.getItem("token")
        },
        body: JSON.stringify(enquiryData)
      });

      if (!response.ok) {
        setLoadingBarProgress(0);
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // Reset form after successful submission
      setEnquiryData({
        enquiryCode: "",
        enquiryDate: "",
        followupDate: "",
        purposeId: "",
        modeId: "",
        classId: "",
        contactNo: "",
        parentAndGurdianName: "",
        reference: "",
        emailId: "",
        remark: "",
        createdBy: 0,
        teacherId: "",
        studentName: "",
        motherName: "",
        amount: 0,
        alternateMobile: ""
      });
      setLoadingBarProgress(100);
      // alert("Enquiry updated successfully!");
      setShowSuccessModal(true);
      // navigate(-1);
    } catch (error) {
      console.error("Error updating enquiry:", error);
      // alert("Failed to submit enquiry. Please check all fields are filled properly.");
      setSnackbarMessage("Failed to submit enquiry. Please check all fields are filled properly.");
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
    }
  };

  const handleReset = () => {
    setEnquiryData({
      enquiryCode: "",
      enquiryDate: "",
      followupDate: "",
      purposeId: "",
      modeId: "",
      classId: "",
      contactNo: "",
      parentAndGurdianName: "",
      reference: "",
      emailId: "",
      remark: "",
      createdBy: 0,
      teacherId: "",
      studentName: "",
      motherName: "",
      amount: 0,
      alternateMobile: ""
    });
  }

  useEffect(() => {
    const fetchDropdownData = async () => {
       setIsLoading(true);
      try {
        const apiUrl = process.env.REACT_APP_BASE_URL;
        const token = sessionStorage.getItem("token");
        const headers = {
          "Content-Type": "application/json",
          "Authorization": token,
        };

        const responses = await Promise.all([
          fetch(`${apiUrl}/Enquiry/ddlMode`, {
            method: "POST",
            headers: headers,
            body: JSON.stringify({})
          }),
          fetch(`${apiUrl}/Enquiry/ddlPurpose`, {
            method: "POST",
            headers: headers,
            body: JSON.stringify({})
          }),
          fetch(`${apiUrl}/Enquiry/ddlClassName`, {
            method: "POST",
            headers: headers,
            body: JSON.stringify({})
          }),
          fetch(`${apiUrl}/Enquiry/ddlTeacher`, {
            method: "POST",
            headers: headers,
            body: JSON.stringify({})
          })
        ]);

        const [modeResponse, purposeResponse, classResponse, subResponse] = responses;

        if (!modeResponse.ok || !purposeResponse.ok || !classResponse.ok || !subResponse.ok) {
          // alert("Failed to fetch dropdown data");
          setSnackbarMessage("Failed to fetch dropdown data");
          setOpenSnackbar(true);
          setSnackbarSeverity("error")
          return;
        }

        const modeData = await modeResponse.json();
        const purposeData = await purposeResponse.json();
        const classData = await classResponse.json();
        const subData = await subResponse.json();

        if (modeData.data === null && modeData.msg === "Record Not Found") {
          console.error('Record Not Found for Mode');
          // alert('Record Not Found for Mode');
          setSnackbarMessage("Record Not Found for Mode");
          setOpenSnackbar(true);
          setSnackbarSeverity("error")
          return;
        }

        if (purposeData.data === null && purposeData.msg === "Record Not Found") {

          return;
        }

        if (classData.data === null && classData.msg === "Record Not Found") {
          console.error('Record Not Found for Class');

          return;
        }

        if (subData.data === null && subData.msg === "Record Not Found") {
          console.error('Record Not Found for Teacher');

          return;
        }

        setModes(modeData);
        setPurposes(purposeData);
        setClasses(classData);
        setSubjects(subData);

      } catch (error) {
        console.error("Error fetching dropdown data:", error);
        // alert("An error occurred. Please try again later.");
        setSnackbarMessage("An error occurred. Please try again later.");
        setOpenSnackbar(true);
        setSnackbarSeverity("error")
      } finally {
    setIsLoading(false);}
    };

    fetchDropdownData();
  }, []);

  const handlePurposeChange = (event) => {
    setEnquiryData({ ...enquiryData, purposeId: event.target.value });
  };
  const handleClassChange = (event) => {
    setEnquiryData({ ...enquiryData, classId: event.target.value });
  };
  const handleSubChange = (event) => {
    setEnquiryData({ ...enquiryData, teacherId: event.target.value });
  };
  const handleModeChange = (event) => {
    setEnquiryData({ ...enquiryData, modeId: event.target.value });
  };


  useEffect(() => {
  const fetchEnquiryData = async () => {
    setIsLoading(true); // Start loading for enquiry data
    try {
      const url = process.env.REACT_APP_BASE_URL;
      const response = await fetch(`${url}/Enquiry/EnquiryId?EnqId=${enquiryId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": sessionStorage.getItem("token")
        }
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch enquiry data for ID ${enquiryId}`);
      }

      const data = await response.json();
      if (data.length > 0) {
        const enquiry = {
          ...data[0],
          teacherId: data[0].assignedId,
        };
        setEnquiryData(enquiry);
      } else {
        throw new Error(`Enquiry with ID ${enquiryId} not found`);
      }
    } catch (error) {
      console.error("Error fetching enquiry data:", error);
      setSnackbarMessage("Failed to fetch enquiry data. Please try again later.");
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    } finally {
      setIsLoading(false); // Stop loading for enquiry data
    }
  };

  fetchEnquiryData();
}, [enquiryId]);

  // Info sections data
  const infoSections = [
    {
      title: "📋 Page Overview",
      content:
        "The Update Enquiry page allows staff to modify an existing student enquiry record. All previously saved details are pre-loaded into the form. Make the required changes and click UPDATE to save.",
    },
    {
      title: "📝 Form Fields",
      items: [
        "Enquiry No. – Auto-generated code for this enquiry. This field is read-only and cannot be edited.",
        "Enquiry Date – The original date when the enquiry was recorded.",
        "Next Follow Up Date – The scheduled date for the next follow-up with the parent/student.",
        "Purpose – Reason for the enquiry (e.g., new admission, transfer, information).",
        "Mode – How the enquiry was received (e.g., walk-in, phone call, online).",
        "For Class – The class/grade the student is enquiring about.",
        "Contact No. – Primary phone number of the parent or guardian.",
        "Father Name – Name of the father or primary guardian.",
        "Student Name – Full name of the prospective student.",
        "Mother Name – Name of the mother.",
        "Alternate Number – A secondary contact number if available.",
        "Email-Id – Email address for correspondence.",
        "Assigned To – Staff member responsible for following up on this enquiry.",
        "Reference – How the family heard about the school (e.g., friend, advertisement).",
        "Remark – Any additional notes or observations about the enquiry.",
      ],
    },
    {
      title: "⚙️ Actions",
      items: [
        "UPDATE – Saves all changes made to the enquiry record.",
        "CANCEL – Discards changes and navigates back to the previous page without saving.",
      ],
    },
    {
      title: "✅ After Updating",
      content:
        "On successful update, a confirmation dialog will appear. Click OK to close the dialog and return to the Enquiry Details list.",
    },
  ];

  return (
    
    <div>
      <Container sx={{ marginTop: 0 }}>
        <Box
          sx={{
            backgroundColor: '#0B1F40',
            padding: '12px 24px',
            boxShadow: 3,
            borderRadius: '4px 4px 0 0',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            // marginBottom: '10px',
          }}
        >
          <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
            Update Enquiry
          </Typography>

          {/* Info Icon Button */}
          <Tooltip title="View page information & guide" arrow>
            <IconButton
              onClick={() => setShowInfoModal(true)}
              size="small"
              sx={{
                color: "rgba(255,255,255,0.75)",
                backgroundColor: "rgba(255,255,255,0.1)",
                border: "1.5px solid rgba(255,255,255,0.25)",
                borderRadius: "50%",
                width: 30,
                height: 30,
                ml: 0.5,
                transition: "all 0.2s ease",
                "&:hover": {
                  backgroundColor: "rgba(100,181,246,0.25)",
                  borderColor: "#64B5F6",
                  color: "#64B5F6",
                  transform: "scale(1.1)",
                },
              }}
            >
              <InfoIcon sx={{ fontSize: 18 }} />
            </IconButton>
          </Tooltip>
        </Box>

   {/* Add the conditional loader here */}
      {isLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : (      
        <form onSubmit={handleSubmit}>
          <Paper elevation={3} style={{ padding: '20px', marginTop: 6, }}>
            <Grid container spacing={2} mt={3}>
              <Grid item md={6}>
                <label htmlFor="enquiryCode"><strong>Enquiry No.</strong></label>
                <TextField
                  id="enquiryCode"
                  type="text"
                  fullWidth
                  value={enquiryData.enquiryCode}
                // onChange={(e) => setEnquiryData({ ...enquiryData, enquiryCode: e.target.value })}
                />
              </Grid>
              <Grid item md={6}>
                <label htmlFor="enquiryDate"><strong>Enquiry Date</strong></label>
                <TextField
                  id="enquiryDate"
                  type="text"
                  fullWidth
                  value={enquiryData.enquiryDate}
                  onChange={(e) => setEnquiryData({ ...enquiryData, enquiryDate: e.target.value })}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} mt={2}>
              <Grid item md={6}>
                <label htmlFor="followupDate"><strong>Next Follow Up Date</strong></label>
                <TextField
                  id="followupDate"
                  type="text"
                  fullWidth
                  value={enquiryData.followupDate}
                  onChange={(e) => setEnquiryData({ ...enquiryData, followupDate: e.target.value })}
                />
              </Grid>
              <Grid item xs={6} marginTop={-1}>
                <label htmlFor="purpose" className="form-label">
                  <strong>Purpose</strong>
                </label>
                <Select
                  id="purpose"
                  value={enquiryData.purposeId}
                  onChange={handlePurposeChange}
                  fullWidth
                >
                  <MenuItem value="">--Select--</MenuItem>
                  {purposes.map((purpose) => (
                    <MenuItem key={purpose.purposeId} value={purpose.purposeId}>
                      {purpose.purpose}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            </Grid>
            <Grid container spacing={2} mt={2}>
              <Grid item xs={6}>
                <label htmlFor="mode" className="form-label">
                  <strong>Mode</strong>
                </label>
                <Select
                  id="mode"
                  value={enquiryData.modeId}
                  onChange={handleModeChange}
                  fullWidth
                >
                  <MenuItem value="">--Select--</MenuItem>
                  {modes.map((mode) => (
                    <MenuItem key={mode.modeId} value={mode.modeId}>
                      {mode.modeName}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
              <Grid item xs={6}>
                <label htmlFor="class" className="form-label">
                  <strong>For Class</strong>
                </label>
                <Select
                  id="class"
                  value={enquiryData.classId}
                  onChange={handleClassChange}
                  fullWidth
                >
                  <MenuItem value="">--Select--</MenuItem>
                  {classes.map((classItem) => (
                    <MenuItem key={classItem.classId} value={classItem.classId}>
                      {classItem.className}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            </Grid>
            <Grid container spacing={2} mt={2}>
              <Grid item md={6}>
                <label htmlFor="contactNo"><strong>Contact No.</strong></label>
                <TextField
                  id="contactNo"
                  type="text"
                  fullWidth
                  value={enquiryData.contactNo}
                  onChange={(e) => setEnquiryData({ ...enquiryData, contactNo: e.target.value })}
                />
              </Grid>
              <Grid item md={6}>
                <label htmlFor="parentAndGurdianName"><strong>Father Name</strong></label>
                <TextField
                  id="parentAndGurdianName"
                  type="text"
                  fullWidth
                  value={enquiryData.parentAndGurdianName}
                  onChange={(e) => setEnquiryData({ ...enquiryData, parentAndGurdianName: e.target.value })}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} mt={2}>
              <Grid item md={6}>
                <label htmlFor="studentName"><strong>Student Name</strong></label>
                <TextField
                  id="studentName"
                  type="text"
                  fullWidth
                  value={enquiryData.studentName}
                  onChange={(e) => setEnquiryData({ ...enquiryData, studentName: e.target.value })}
                />
              </Grid>
              <Grid item md={6}>
                <label htmlFor="motherName"><strong>Mother Name</strong></label>
                <TextField
                  id="motherName"
                  type="text"
                  fullWidth
                  value={enquiryData.motherName}
                  onChange={(e) => setEnquiryData({ ...enquiryData, motherName: e.target.value })}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} mt={2}>
              <Grid item md={6}>
                <label htmlFor="alternateMobile"><strong>Alternate number</strong></label>
                <TextField
                  id="alternateMobile"
                  type="text"
                  fullWidth
                  value={enquiryData.alternateMobile}
                  onChange={(e) => setEnquiryData({ ...enquiryData, alternateMobile: e.target.value })}
                />
              </Grid>
              <Grid item md={6}>
                <label htmlFor="emailId"><strong>Email-Id</strong></label>
                <TextField
                  id="emailId"
                  type="text"
                  fullWidth
                  value={enquiryData.emailId}
                  onChange={(e) => setEnquiryData({ ...enquiryData, emailId: e.target.value })}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} mt={2}>
              <Grid item xs={6} marginTop={-1}>
                <label htmlFor="teacherId" className="form-label">
                  <strong>Assigned To</strong>
                </label>
                <Select
                  id="teacherId"
                  value={enquiryData.teacherId} // Change from assignedId to teacherId
                  onChange={handleSubChange} // This should update teacherId
                  fullWidth
                >
                  <MenuItem value="">--Select--</MenuItem>
                  {subjects.map((subject) => (
                    <MenuItem key={subject.userId} value={subject.userId}>
                      {subject.employeeName}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>

              <Grid item md={6}>
                <label htmlFor="reference"><strong>Reference</strong></label>
                <TextField
                  id="reference"
                  type="text"
                  fullWidth
                  value={enquiryData.reference}
                  onChange={(e) => setEnquiryData({ ...enquiryData, reference: e.target.value })}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} mt={2}>
              <Grid item xs={6}>
                <label htmlFor="remark"><strong>Remark</strong></label>
                <TextField
                  id="remark"
                  type="text"
                  fullWidth
                  value={enquiryData.remark}
                  onChange={(e) => setEnquiryData({ ...enquiryData, remark: e.target.value })}
                />
              </Grid>
              {/* Additional fields can be added here */}
            </Grid>
            <Grid item xs={6}>
              <Button type="submit" variant="contained" color="primary" sx={{
                marginTop: 2, width: "100px",
                height: "50px",
                padding: "10px 0",
                fontWeight: 'bold'
              }}>
                UPDATE
              </Button>
              <Button type="button" variant="contained" color="error" sx={{
                marginTop: 2, marginLeft: 2, width: "100px",
                height: "50px",
                padding: "10px 0",
                fontWeight: 'bold'
              }} onClick={() => { navigate(-1) }}>
                CANCEL
              </Button>
            </Grid>
          </Paper>
        </form>
              )}

        </Container>

      {/* ===== Info Modal ===== */}
      <Modal
        open={showInfoModal}
        onClose={() => setShowInfoModal(false)}
        aria-labelledby="info-modal-title"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '95%', sm: 620 },
            maxHeight: '85vh',
            bgcolor: 'background.paper',
            borderRadius: 3,
            boxShadow: '0 8px 40px rgba(11,31,61,0.22)',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {/* Modal Header */}
          <Box
            sx={{
              backgroundColor: '#0B1F3D',
              padding: '14px 20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <InfoIcon sx={{ color: '#64B5F6', fontSize: 22 }} />
              <Typography id="info-modal-title" variant="h6" sx={{ color: '#fff', fontWeight: 700 }}>
                Update Enquiry — Page Guide
              </Typography>
            </Box>
           
          </Box>

          {/* Modal Body — scrollable */}
          <Box sx={{ overflowY: 'auto', padding: '20px 24px', flex: 1 }}>
            {infoSections.map((section, idx) => (
              <Box key={idx} sx={{ mb: 2.5 }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 700,
                    color: '#0B1F3D',
                    mb: 0.8,
                    fontSize: '0.97rem',
                  }}
                >
                  {section.title}
                </Typography>

                {section.content && (
                  <Typography
                    variant="body2"
                    sx={{ color: '#444', lineHeight: 1.7, fontSize: '0.875rem' }}
                  >
                    {section.content}
                  </Typography>
                )}

                {section.items && (
                  <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
                    {section.items.map((item, i) => (
                      <Box
                        component="li"
                        key={i}
                        sx={{
                          fontSize: '0.875rem',
                          color: '#444',
                          lineHeight: 1.75,
                          mb: 0.3,
                        }}
                      >
                        {item}
                      </Box>
                    ))}
                  </Box>
                )}

                {idx < infoSections.length - 1 && (
                  <Divider sx={{ mt: 2, borderColor: 'rgba(11,31,61,0.08)' }} />
                )}
              </Box>
            ))}
          </Box>

          {/* Modal Footer */}
          <Box
            sx={{
              padding: '12px 24px',
              borderTop: '1px solid rgba(11,31,61,0.1)',
              display: 'flex',
              justifyContent: 'flex-end',
              backgroundColor: '#f9fafb',
            }}
          >
            <Button
              variant="contained"
              onClick={() => setShowInfoModal(false)}
              sx={{
                backgroundColor: '#0B1F3D',
                textTransform: 'none',
                fontWeight: 600,
                '&:hover': { backgroundColor: '#1a3560' },
              }}
            >
              Got it
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Updatted ✅
            </Typography>
          </Box>

          {/* Content */}
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              Enquiry updated successfully!
            </Typography>

            {/* Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1); // go back after closing modal
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

<Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>

    </div>
  );
}

export default UpdateEnquiry;